/**
 * Centralized redirect map: old path → new path
 * Replaces ~300 individual <Route> redirect elements
 * to reduce React Router overhead from ~700 to ~210 route nodes.
 */
export const redirectMap: Record<string, string> = {
  "/affordable-movers-near-me": "/cheap-moving-companies-near-me",
  "/affordable-moving-companies-in-chicago-a-guide-to-budget-friendly-relocation": "/cheap-movers-chicago",
  "/all-time-movers": "/",
  "/best-moving-company-near-me": "/best-movers-near-me",
  "/best-rated-movers-near-me": "/best-movers-near-me",
  "/blogs": "/blog",
  "/blogs/": "/blog",
  "/budget-movers": "/moving-services/competitive-pricing",
  "/budget-movers/": "/moving-services/competitive-pricing",
  "/cheap-moves-near-me": "/cheap-moving-companies-near-me",
  "/cheapest-way-to-move-locally": "/moving-services/local-move",
  "/cheapest-way-to-move-locally/": "/moving-services/local-move",
  "/chicago-movers": "/service-areas/movers/chicago",
  "/chicago-movers-long-distance-experts": "/moving-services/long-distance-move",
  "/chicago-movers-long-distance-experts/": "/moving-services/long-distance-move",
  "/commercial-move-img": "/moving-services/commercial",
  "/commercial-move-img/": "/moving-services/commercial",
  "/commercial-moving": "/moving-services/commercial",
  "/commercial-moving/": "/moving-services/commercial",
  "/common-moving-mistakes-and-how-to-avoid-them": "/blog",
  "/common-moving-mistakes-and-how-to-avoid-them/": "/blog",
  "/compare-moving-companies": "/about",
  "/compare-moving-companies/": "/about",
  "/competitive-pricing": "/moving-services/competitive-pricing",
  "/competitive-pricing/": "/moving-services/competitive-pricing",
  "/contact-lifetime-movers-chicago": "/contact",
  "/contact-lifetime-movers-chicago/": "/contact",
  "/cost-of-moving-in-chicagoland": "/affordable-moving-company-chicago",
  "/cost-of-moving-in-chicagoland-breaking-down-naperville-oak-brook-and-beyond": "/affordable-moving-company-chicago",
  "/cost-of-moving-in-chicagoland-breaking-down-naperville-oak-brook-and-beyond/": "/affordable-moving-company-chicago",
  "/cost-of-moving-in-chicagoland/": "/affordable-moving-company-chicago",
  "/discover-the-joy-of-easy-moving-in-elmhurst": "/service-areas/movers/elmhurst",
  "/form-get-a-quote": "/quote",
  "/form-get-a-quote/": "/quote",
  "/free-moving-quotes-from-local-movers": "/quote",
  "/free-moving-quotes-from-local-movers/": "/quote",
  "/furniture-movers-near-me": "/movers-near-me",
  "/furniture-moving": "/moving-services/residential",
  "/furniture-moving/": "/moving-services/residential",
  "/gallery": "/about-us",
  "/gallery/": "/about-us",
  "/guide-for-a-smooth-move-in-chicago": "/best-times-of-the-year-to-move-in-chicago",
  "/guide-for-a-smooth-move-in-chicago/": "/best-times-of-the-year-to-move-in-chicago",
  "/guide-to-a-stress-free-move-in-naperville": "/blog",
  "/guide-to-a-stress-free-move-in-naperville/": "/blog",
  "/home-movers-near-me": "/movers-near-me",
  "/house-mover": "/moving-services/residential",
  "/house-mover/": "/moving-services/residential",
  "/house-movers-near-me": "/movers-near-me",
  "/household-moving-company": "/moving-services/household-moving",
  "/household-moving-company/": "/moving-services/household-moving",
  "/how-to-choose-the-right-moving-service-in-chicago": "/blog",
  "/how-to-choose-the-right-moving-service-in-chicago/": "/blog",
  "/i-need-a-moving-truck": "/quote",
  "/i-need-a-moving-truck/": "/quote",
  "/interstate-movers-near-me": "/interstate-movers",
  "/lifetime-movers-payments": "/",
  "/lifetime-movers-payments/": "/",
  "/local-mover-quotes": "/chicago-moving-quotes",
  "/local-mover-quotes/": "/local-mover-quotes",
  "/local-moving-2": "/moving-services/local-move",
  "/moving-services/local-moving": "/moving-services/local-move",
  "/local-moving-2/": "/moving-services/local-move",
  "/local-moving-company-near-me": "/local-movers-near-me",
  "/locations": "/service-areas",
  "/locations-wilmette-movers": "/service-areas/movers/wilmette",
  "/locations/": "/service-areas",
  "/locations/addison-movers": "/service-areas/movers/addison",
  "/locations/barrington-il-movers": "/service-areas/movers/barrington",
  "/locations/barrington-il-movers/": "/service-areas/movers/barrington",
  "/locations/berwyn-movers": "/service-areas/movers/berwyn",
  "/locations/brookfield-movers": "/service-areas/movers/brookfield",
  "/locations/bucktown-chicago-movers": "/service-areas/movers/bucktown",
  "/locations/carol-stream-movers": "/service-areas/movers/carol-stream",
  "/locations/clarendon-hills-movers": "/service-areas/movers/clarendon-hills",
  "/locations/darien-movers": "/service-areas/movers/darien",
  "/locations/des-plaines-movers": "/service-areas/movers/des-plaines",
  "/locations/elmhurst-il-movers": "/service-areas/movers/elmhurst",
  "/locations/elmhurst-il-movers/": "/service-areas/movers/elmhurst",
  "/locations/forest-park-movers": "/service-areas/movers/forest-park",
  "/locations/glen-ellyn-movers": "/service-areas/movers/glen-ellyn",
  "/locations/gold-coast-chicago-movers": "/service-areas/movers/gold-coast",
  "/locations/gold-coast-chicago-movers/": "/service-areas/movers/gold-coast",
  "/locations/highland-park-il-movers": "/service-areas/movers/highland-park",
  "/locations/highland-park-il-movers/": "/service-areas/movers/highland-park",
  "/locations/hinsdale-movers-il": "/locations/hinsdale-movers",
  "/locations/hinsdale-movers-il/": "/locations/hinsdale-movers",
  "/locations/homer-glen-il-movers": "/service-areas/movers/homer-glen",
  "/locations/inverness-il-movers": "/service-areas/movers/inverness",
  "/locations/inverness-il-movers/": "/service-areas/movers/inverness",
  "/locations/itasca-movers": "/service-areas/movers/itasca",
  "/locations/kildeer-il-movers": "/service-areas/movers/kildeer",
  "/locations/kildeer-il-movers/": "/service-areas/movers/kildeer",
  "/locations/lakeview-chicago-movers": "/service-areas/movers/lakeview",
  "/locations/lincolnshire-il-movers": "/service-areas/movers/lincolnshire",
  "/locations/lincolnshire-il-movers/": "/service-areas/movers/lincolnshire",
  "/locations/lisle-movers": "/service-areas/movers/lisle",
  "/locations/lombard-movers": "/service-areas/movers/lombard",
  "/locations/movers-in-barrington-il": "/service-areas/movers/barrington",
  "/locations/movers-in-barrington-il/": "/service-areas/movers/barrington",
  "/locations/movers-in-chicago": "/service-areas/movers/chicago",
  "/locations/movers-in-chicago/": "/service-areas/movers/chicago",
  "/locations/movers-in-deer-park-il": "/service-areas/movers/deer-park",
  "/locations/movers-in-elmhurst": "/service-areas/movers/elmhurst",
  "/locations/movers-in-elmhurst/": "/service-areas/movers/elmhurst",
  "/locations/movers-in-geneva": "/service-areas/movers/geneva",
  "/locations/movers-in-geneva/": "/service-areas/movers/geneva",
  "/locations/movers-in-lake-forest": "/service-areas/movers/lake-forest",
  "/locations/movers-in-lake-forest/": "/service-areas/movers/lake-forest",
  "/locations/movers-in-lemont": "/service-areas/movers/lemont",
  "/locations/movers-in-lemont/": "/service-areas/movers/lemont",
  "/locations/movers-in-lincolnshire": "/service-areas/movers/lincolnshire",
  "/locations/movers-in-lincolnshire/": "/service-areas/movers/lincolnshire",
  "/locations/movers-in-northfield-il": "/movers-in-northfield-illinois",
  "/locations/movers-in-northfield-il/": "/movers-in-northfield-illinois",
  "/locations/movers-in-northield-il": "/movers-in-northfield-illinois",
  "/locations/movers-in-northield-il/": "/movers-in-northfield-illinois",
  "/locations/movers-in-old-town-il": "/service-areas/movers/old-town",
  "/locations/movers-in-vernon-hills": "/service-areas/movers/vernon-hills",
  "/locations/movers-in-vernon-hills/": "/service-areas/movers/vernon-hills",
  "/locations/movers-oak-brook": "/oak-brook-movers-illinois",
  "/locations/movers-oak-brook/": "/oak-brook-movers-illinois",
  "/locations/movers-in-winnetka-il": "/service-areas/movers/winnetka",
  "/locations/movers-in-winnetka-il/": "/service-areas/movers/winnetka",
  "/locations/movers-lake-forest": "/service-areas/movers/lake-forest",
  "/locations/northbrook-il-movers": "/service-areas/movers/northbrook",
  "/locations/northfield-il-movers": "/movers-in-northfield-illinois",
  "/locations/riverside-movers": "/service-areas/movers/riverside",
  "/locations/roselle-movers": "/service-areas/movers/roselle",
  "/locations/skokie-movers": "/service-areas/movers/skokie",
  "/locations/south-loop-chicago-movers": "/service-areas/movers/south-loop",
  "/locations/south-loop-chicago-movers/": "/service-areas/movers/south-loop",
  "/locations/streeterville-chicago-movers": "/service-areas/movers/streeterville",
  "/locations/streeterville-chicago-movers/": "/service-areas/movers/streeterville",
  "/locations/villa-park-movers": "/service-areas/movers/villa-park",
  "/locations/western-springs-il-movers": "/service-areas/movers/western-springs",
  "/locations/western-springs-il-movers/": "/service-areas/movers/western-springs",
  "/locations/westmont-movers": "/service-areas/movers/westmont",
  "/locations/wheaton-movers": "/service-areas/movers/wheaton",
  "/locations/willowbrook-movers": "/service-areas/movers/willowbrook",
  "/locations/winnetka-il-movers": "/service-areas/movers/winnetka",
  "/locations/winnetka-il-movers/": "/service-areas/movers/winnetka",
  "/long-distance-moving-companies-near-me": "/long-distance-movers-chicago",
  "/long-distance-relocation": "/moving-services/long-distance-move",
  "/long-distance-relocation/": "/moving-services/long-distance-move",
  "/long-grove-il-movers": "/service-areas/movers/long-grove",
  "/long-grove-il-movers/": "/service-areas/movers/long-grove",
  "/mover-in-chicago": "/mover-chicago",
  "/movers-bridgeport": "/service-areas",
  "/movers-bridgeport/": "/service-areas",
  "/movers-california": "/service-areas",
  "/movers-california/": "/service-areas",
  "/movers-chicago-area": "/movers-in-chicago-area",
  "/movers-dallas": "/service-areas/movers/dallas",
  "/movers-dallas/": "/service-areas/movers/dallas",
  "/movers-fairfield": "/service-areas/movers/fairfield",
  "/movers-fairfield/": "/service-areas/movers/fairfield",
  "/movers-fremont": "/movers/california",
  "/movers-fremont/": "/movers/california",
  "/movers-il": "/movers-in-illinois",
  "/movers-in-bucktown-chicago": "/service-areas/movers/bucktown",
  "/movers-in-bucktown-chicago/": "/service-areas/movers/bucktown",
  "/movers-in-burr-ridge-illinois": "/service-areas/movers/burr-ridge",
  "/movers-in-burr-ridge-illinois/": "/service-areas/movers/burr-ridge",
  "/movers-in-downers-grove": "/movers-downers-grove-il",
  "/movers-in-downers-grove-illinois": "/service-areas/movers/downers-grove",
  "/movers-in-elmhurst-il": "/service-areas/movers/elmhurst",
  "/movers-in-elmhurst-il/": "/service-areas/movers/elmhurst",
  "/movers-in-glencoe-illinois": "/service-areas/movers/glencoe",
  "/movers-in-glencoe-illinois/": "/service-areas/movers/glencoe",
  "/movers-in-hinsdale": "/locations/hinsdale-movers",
  "/movers-in-hinsdale/": "/locations/hinsdale-movers",
  "/movers-in-long-grove-il": "/service-areas/movers/long-grove",
  "/movers-in-northbrook-illinois": "/service-areas/movers/northbrook",
  "/movers-in-northbrook-illinois/": "/service-areas/movers/northbrook",
  "/movers-in-old-town-il": "/service-areas/movers/old-town",
  "/movers-in-old-town-il/": "/service-areas/movers/old-town",
  "/movers-in-pingree-grove-il": "/service-areas/movers/pingree-grove",
  "/movers-in-pingree-grove-il/": "/service-areas/movers/pingree-grove",
  "/movers-in-south-loop-chicago": "/service-areas/movers/chicago",
  "/movers-in-south-loop-chicago/": "/service-areas/movers/chicago",
  "/movers-in-vernon-hills-il": "/service-areas/movers/vernon-hills",
  "/movers-in-vernon-hills-il/": "/service-areas/movers/vernon-hills",
  "/movers-in-wisconsin": "/service-areas",
  "/movers-in-wisconsin/": "/service-areas",
  "/movers-irvine": "/service-areas/movers/irvine",
  "/movers-irvine/": "/service-areas/movers/irvine",
  "/movers-lombard": "/movers-lombard-il",
  "/movers-lubbock": "/service-areas/movers/lubbock",
  "/movers-lubbock/": "/service-areas/movers/lubbock",
  "/movers-near-burr-ridge-illinois": "/service-areas/movers/burr-ridge",
  "/movers-near-burr-ridge-illinois/": "/service-areas/movers/burr-ridge",
  "/movers-near-me-with-a-truck": "/movers-near-me",
  "/movers-oak-brook-il": "/oak-brook-movers-illinois",
  "/movers-oakland": "/movers/california",
  "/movers-oakland/": "/movers/california",
  "/movers-san-francisco": "/service-areas/movers/san-francisco",
  "/movers-san-francisco/": "/service-areas/movers/san-francisco",
  "/movers-santa-ana": "/movers/california",
  "/movers-santa-ana/": "/movers/california",
  "/movers-texas": "/service-areas",
  "/movers-texas/": "/service-areas",
  "/movers-waterbury": "/service-areas",
  "/movers-waterbury/": "/service-areas",
  "/movers-westport": "/service-areas",
  "/movers-westport/": "/service-areas",
  "/movers/indiana": "/service-areas",
  "/movers/michigan": "/service-areas",
  "/movers/wisconsin": "/wisconsin-movers",
  "/moving-companies-lombard": "/moving-companies-lombard-il",
  "/moving-companies-st-charles": "/service-areas/movers/st-charles",
  "/moving-company-near-me": "/moving-companies-near-me",
  "/moving-company-recommendations": "/best-movers-near-me",
  "/moving-during-the-winter-in-naperville-challenges-and-how-to-overcome-them": "/blog",
  "/moving-during-the-winter-in-naperville-challenges-and-how-to-overcome-them/": "/blog",
  "/moving-near-me": "/movers-near-me",
  "/moving-service-in-chicago": "/service-areas/movers/chicago",
  "/moving-service-in-chicago/": "/service-areas/movers/chicago",
  "/moving-services-near-me": "/movers-near-me",
  "/moving-services/commercial-move": "/moving-services/commercial",
  "/moving-services/commercial-move/": "/moving-services/commercial",
  "/moving-services/commercial-moving": "/moving-services/commercial",
  "/moving-services/commercial-moving/": "/moving-services/commercial",
  "/moving-services/full-moving-services": "/moving-services/full-service",
  "/moving-services/interstate-moving": "/moving-services/interstate-move",
  "/moving-services/long-distance-moving": "/moving-services/long-distance-move",
  "/moving-services/packing-services": "/moving-services/packing-service",
  "/moving-services/packing-services/": "/moving-services/packing-service",
  "/moving-services/residential-moving": "/moving-services/residential",
  "/moving-services/same-day-move": "/moving-services/same-day",
  "/moving-services/senior-move": "/moving-services/senior-movers",
  "/moving-supplies": "/moving-services/moving-supplies",
  "/moving-supplies/": "/moving-services/moving-supplies",
  "/moving-to-oak-brook-heres-what-you-need-to-know": "/oak-brook-movers-illinois",
  "/moving-to-oak-brook-heres-what-you-need-to-know/": "/oak-brook-movers-illinois",
  "/moving-to-wisconsin-from-illinois": "/wisconsin-movers",
  "/naperville": "/service-areas/movers/naperville",
  
  "/naperville/": "/service-areas/movers/naperville",
  "/national-home-movers": "/national-moving-company",
  "/oak-brook-movers": "/oak-brook-movers-illinois",
  "/office-relocations-in-chicago": "/moving-services/commercial",
  "/office-relocations-in-chicago/": "/moving-services/commercial",
  "/packing-moving": "/moving-services/packing-service",
  "/packing-moving/": "/moving-services/packing-service",
  "/packing-service-img": "/moving-services/packing-service",
  "/packing-service-img/": "/moving-services/packing-service",
  "/packing-services-2": "/moving-services/packing-service",
  "/packing-services-2/": "/moving-services/packing-service",
  "/payment": "/",
  "/payment/": "/",
  "/privacy-policy": "/privacy",
  "/privacy-policy/": "/privacy",
  "/professional-movers": "/professional-movers-chicago",
  "/professional-movers/": "/professional-movers-chicago",
  "/quick-movers": "/moving-services/quick-pickup",
  "/quick-movers/": "/moving-services/quick-pickup",
  "/request-quote": "/quote",
  "/request-quote/": "/quote",
  "/residential-movers": "/moving-services/residential",
  "/residential-movers/": "/moving-services/residential",
  "/residential-moving": "/moving-services/residential",
  "/residential-moving/": "/moving-services/residential",
  "/same-day-and-emergency-moving-services": "/moving-services/same-day",
  "/same-day-and-emergency-moving-services/": "/moving-services/same-day",
  "/senior-movers": "/moving-services/senior-movers",
  "/piano-movers": "/moving-services/piano-movers",
  "/full-service-movers": "/moving-services/full-service",
  "/service-areas/movers/hinsdale": "/locations/hinsdale-movers",
  "/service-areas/movers/lake-barrington": "/locations/lake-barrington-il-movers",
  "/service-areas/movers/lincoln-park": "/locations/lincoln-park-chicago-movers",
  "/locations/lincoln-park-movers": "/locations/lincoln-park-chicago-movers",
  "/locations/lincoln-park-movers/": "/locations/lincoln-park-chicago-movers",
  "/locations/home-movers-in-naperville-il": "/service-areas/movers/naperville",
  "/locations/home-movers-in-naperville-il/": "/service-areas/movers/naperville",
  "/service-areas/movers/new-york-city": "/service-areas/movers/new-york",
  "/service-areas/movers/new-york-city/": "/service-areas/movers/new-york",
  "/service-areas/movers/northfield": "/movers-in-northfield-illinois",
  "/service-areas/movers/oak-brook": "/oak-brook-movers-illinois",
  "/service-areas/movers/st.-charles": "/service-areas/movers/st-charles",
  "/service-areas/movers/st.-louis": "/service-areas/movers/st-louis",
  "/service-areas/movers/west-loop": "/locations/west-loop-il-movers",
  "/services": "/moving-services",
  "/services/": "/moving-services",
  "/services/full-service-moving": "/moving-services/full-service",
  "/services/full-service-moving/": "/moving-services/full-service",
  "/services/long-distance-move": "/moving-services/long-distance-move",
  "/services/long-distance-move/": "/moving-services/long-distance-move",
  "/small-moves-near-me": "/local-movers-near-me",
  "/small-moving-company-near-me": "/local-movers-near-me",
  "/terms-and-conditions": "/terms",
  "/terms-and-conditions/": "/terms",
  "/the-ultimate-moving-checklist-everything-you-need-to-know-before-during-and-after-your-move": "/blog",
  "/the-ultimate-moving-checklist-everything-you-need-to-know-before-during-and-after-your-move/": "/blog",
  "/the-ultimate-moving-guide-tips-for-every-type-of-mover": "/blog",
  "/the-ultimate-moving-guide-tips-for-every-type-of-mover/": "/blog",
  "/locations/wisconsin-movers": "/wisconsin-movers",
  "/locations/wisconsin-movers/": "/wisconsin-movers",
  "/blog/common-moving-mistakes-to-avoid": "/blog/common-moving-mistakes-avoid-smooth-relocation",
  "/blog/interstate-moving-guide-chicago": "/blog/interstate-moving-from-chicago-complete-guide",
  "/blog/cost-of-moving-a-3-bedroom-house": "/blog/cost-of-moving-in-naperville-il-2026-guide",
  "/wp-json/*": "/",
  "/your-ultimate-moving-guide-stress-free-relocation-in-northbrook-il": "/blog",
  "/your-ultimate-moving-guide-stress-free-relocation-in-northbrook-il/": "/blog",

  // SEO Fix: 43 blocked pages — April 2026
  // Group A: Wrong URL → Correct Route
  "/about": "/about-us",
  "/estimate": "/quote",
  "/best-times-to-move-chicago": "/best-times-of-the-year-to-move-in-chicago",
  "/how-many-movers-for-2-bedroom": "/how-many-movers-do-i-need-for-a-2-bedroom-apartment",
  "/local-movers-il": "/local-mover-il",
  "/moving-services/full-service-movers": "/moving-services/full-service",
  "/moving-services/interstate-movers": "/moving-services/interstate-move",
  "/moving-services/local-movers": "/moving-services/local-move",
  "/moving-services/long-distance": "/moving-services/long-distance-move",
  "/moving-services/office": "/moving-services/office-move",
  "/moving-services/office-movers": "/moving-services/office-move",
  "/moving-services/storage": "/moving-services/storage-services",
  "/moving-services/moving-with-kids": "/moving-with-kids-in-chicagoland",
  "/services/moving-supplies": "/moving-services/moving-supplies",
  "/services/packing-service": "/moving-services/packing-service",
  "/long-distance-moving-services": "/moving-services/long-distance-move",

  // Group B: State pages → /service-areas
  "/movers/arizona": "/service-areas",
  "/movers/colorado": "/service-areas",
  "/movers/north-carolina": "/service-areas",
  "/movers/tennessee": "/service-areas",
  "/movers/washington": "/service-areas",

  // Group C: Delivery/Pickup cities
  "/movers/delivery/charlotte": "/service-areas",
  "/movers/delivery/dallas": "/service-areas/movers/dallas",
  "/movers/delivery/houston": "/service-areas",
  "/movers/delivery/los-angeles": "/service-areas/movers/los-angeles",
  "/movers/delivery/phoenix": "/service-areas",
  "/movers/delivery/raleigh": "/service-areas",
  "/movers/delivery/san-diego": "/service-areas",
  "/movers/pickup/downers-grove": "/service-areas/movers/downers-grove",
  "/movers/pickup/elmhurst": "/service-areas/movers/elmhurst",
  "/movers/pickup/glen-ellyn": "/service-areas",
  "/movers/pickup/lombard": "/service-areas/movers/lombard",
  "/movers/pickup/villa-park": "/service-areas/movers/villa-park",

  // Group D: Location pages → /service-areas
  // (batavia + glenview now point to their nearest live city page below)

  "/service-areas/movers/la-grange": "/service-areas",
  "/service-areas/movers/romeoville": "/service-areas",
  "/service-areas/movers/sycamore": "/service-areas",
  "/service-areas/movers/wicker-park": "/service-areas",

  // Group E: Blog/content pages
  "/moving-to-south-loop-chicago-complete-neighborhood-guide": "/service-areas/movers/south-loop",

  // Blocked by robots meta tag fixes - April 2026
  "/movers/delivery/atlanta": "/service-areas/movers/atlanta",
  "/movers/florida": "/service-areas",
  "/moving-to-chicago": "/service-areas/movers/chicago",

  // GSC "Crawled - currently not indexed" recovery - April 2026
  // 404'd URLs → 301 to canonical equivalents
  "/movers-in-joliet-illinois": "/service-areas/movers/joliet",
  "/movers-in-joliet-illinois/": "/service-areas/movers/joliet",
  "/movers-charlotte-nc": "/service-areas/movers/charlotte",
  "/movers-charlotte-nc/": "/service-areas/movers/charlotte",
  "/blog/best-movers-evanston-illinois-2024-guide": "/service-areas/movers/evanston",
  "/blog/best-movers-evanston-illinois-2024-guide/": "/service-areas/movers/evanston",

  // GSC May 2026 cleanup — legacy URLs still receiving impressions
  "/locations/illinois-movers": "/movers-in-illinois",
  "/locations/illinois-movers/": "/movers-in-illinois",
  "/locations/river-north-chicago-movers": "/service-areas/movers/chicago",
  "/locations/river-north-chicago-movers/": "/service-areas/movers/chicago",
  "/moving-services/interstate-moving/": "/moving-services/interstate-move",
  "/why-moving-to-wilmette-il-has-never-been-easier": "/service-areas/movers/wilmette",
  "/why-moving-to-wilmette-il-has-never-been-easier/": "/service-areas/movers/wilmette",

  // June 2026 Semrush cleanup — unknown slugs serving homepage shell (no canonical → soft-duplicate)
  "/local-movers-chicago": "/chicago-local-movers",
  "/local-movers-chicago/": "/chicago-local-movers",
  "/piano-movers-chicago": "/moving-services/piano-movers",
  "/piano-movers-chicago/": "/moving-services/piano-movers",
  "/commercial-movers-chicago": "/moving-services/commercial",
  "/commercial-movers-chicago/": "/moving-services/commercial",
  "/senior-movers-chicago": "/moving-services/senior-movers",
  "/senior-movers-chicago/": "/moving-services/senior-movers",
  "/blog/commercial-moving-tips": "/blog/commercial-movers-chicago-office-restaurant-industrial-moving",
  "/blog/commercial-moving-tips/": "/blog/commercial-movers-chicago-office-restaurant-industrial-moving",
  "/blog/office-moving-checklist": "/moving-services/commercial",
  "/blog/office-moving-checklist/": "/moving-services/commercial",
  "/blog/moving-to-naperville-illinois-guide": "/blog/moving-to-naperville-illinois-complete-relocation-guide",
  "/blog/moving-to-naperville-illinois-guide/": "/blog/moving-to-naperville-illinois-complete-relocation-guide",
  "/faq/contact-reviews": "/contact",
  "/faq/contact-reviews/": "/contact",

  // GSC 2026-09-06: dead ends still crawled by Google (missing blog posts,
  // never-built suburb pages, stray legacy paths) → nearest live page.
  "/blog/commercial-moving-tips-chicago-office-restaurant-industrial-moving": "/blog/commercial-movers-chicago-office-restaurant-industrial-moving",
  "/blog/commercial-moving-tips-chicago-office-restaurant-industrial-moving/": "/blog/commercial-movers-chicago-office-restaurant-industrial-moving",
  "/blog/long-distance-moving-guide": "/blog/long-distance-movers-chicago-guide",
  "/blog/long-distance-moving-guide/": "/blog/long-distance-movers-chicago-guide",
  "/locations/bensenville-movers": "/service-areas/movers/bensenville",
  "/locations/bensenville-movers/": "/service-areas/movers/bensenville",
  "/movers-in-kenilworth-il": "/service-areas/movers/kenilworth",
  "/movers-in-kenilworth-il/": "/service-areas/movers/kenilworth",
  "/service-areas/movers/the-loop": "/service-areas/movers/loop",
  "/service-areas/movers/the-loop/": "/service-areas/movers/loop",
  "/moving-tips": "/blog",
  "/moving-tips/": "/blog",
  "/full-moving-services": "/moving-services/full-service",
  "/full-moving-services/": "/moving-services/full-service",
  "/ful": "/moving-services/full-service",
  "/ful/": "/moving-services/full-service",
};

